import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Monitor, Tv, Smartphone, Settings, Star, LogOut, User } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const Index = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img
              src="https://locaninja.com/logotipo-watch.png"
              alt="Watch Logo"
              className="h-12 w-auto"
            />
          </div>
          {user ? (
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm">
                <User className="h-4 w-4 text-green-600" />
                <span className="text-green-700 font-medium">{user.email}</span>
              </div>
              <Button
                onClick={() => signOut()}
                className="bg-red-600 hover:bg-red-700 text-white font-semibold shadow-lg transition-all duration-200 flex items-center space-x-2"
              >
                <LogOut className="h-4 w-4" />
                <span>Sair</span>
              </Button>
            </div>
          ) : (
            <Button
              onClick={() => navigate("/auth")}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg transition-all duration-200"
            >
              Entrar
            </Button>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <main className="container mx-auto px-4 py-8">
        <div className="text-left mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 tracking-tight">
            Painel Geral
          </h1>
          <p className="text-lg text-gray-500 max-w-2xl font-light">
            Central de controle integrada para gestão de mídias e dispositivos.
          </p>
        </div>

        {/* Cards de Funcionalidades */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
            <CardHeader className="text-center pb-4 flex-1">
              <div className="flex justify-center mb-4">
                <Star className="h-12 w-12 text-green-500" />
              </div>
              <CardTitle className="text-2xl text-green-800">Planos e Recursos</CardTitle>
              <CardDescription className="text-base text-green-600">
                Conheça todos os recursos e escolha o melhor plano para seu negócio
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center mt-auto">
              <Button
                onClick={() => navigate("/landing")}
                className="w-full h-12 bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg transition-all duration-200"
              >
                Ver Planos
              </Button>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
            <CardHeader className="text-center pb-4 flex-1">
              <div className="flex justify-center mb-4">
                <Tv className="h-12 w-12 text-green-500" />
              </div>
              <CardTitle className="text-2xl text-green-800">Dashboard</CardTitle>
              <CardDescription className="text-base text-green-600">
                Gerencie suas mídias, telas e dispositivos de forma intuitiva
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center mt-auto">
              <Button
                onClick={() => navigate("/dashboard")}
                className="w-full h-12 bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg transition-all duration-200"
              >
                Acessar Dashboard
              </Button>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
            <CardHeader className="text-center pb-4 flex-1">
              <div className="flex justify-center mb-4">
                <Smartphone className="h-12 w-12 text-green-500" />
              </div>
              <CardTitle className="text-2xl text-green-800">Player</CardTitle>
              <CardDescription className="text-base text-green-600">
                Visualize como suas mídias aparecem no player em tempo real
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center mt-auto">
              <Button
                onClick={() => navigate("/player")}
                className="w-full h-12 bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg transition-all duration-200"
              >
                Abrir Player
              </Button>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
            <CardHeader className="text-center pb-4 flex-1">
              <div className="flex justify-center mb-4">
                <Settings className="h-12 w-12 text-green-500" />
              </div>
              <CardTitle className="text-2xl text-green-800">Dashboard Master</CardTitle>
              <CardDescription className="text-base text-green-600">
                Acesso administrativo para gerenciamento avançado do sistema
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center mt-auto">
              <Button
                onClick={() => navigate("/admin-dashboard")}
                className="w-full h-12 bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg transition-all duration-200"
              >
                Acessar Dashboard Master
              </Button>
            </CardContent>
          </Card>
        </div>
      </main>

      {/* Footer */}
      <footer className="container mx-auto px-4 py-6 mt-8 border-t border-gray-200">
        <p className="text-center text-sm text-gray-500">
          © 2026 Watch Technologies | Smart Media. Todos os direitos reservados.
        </p>
      </footer>
    </div>
  );
};

export default Index;
